import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    const timer = window.setTimeout(() => {
      const heading = document.querySelector('#main-content h1');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
        document.title = `${heading.textContent.trim()} | Home Style`;
      }
    }, 250);
    return () => window.clearTimeout(timer);
  }, [pathname]);
  return null;
}
